import React, {useEffect, useState} from 'react';
import { Pagination } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { axios } from "../../axios";
import {DebounceInput} from 'react-debounce-input';
const Filter = ({setPost,setLoading,path}) => {
    const [title,setTitle] = useState('')
    const [page, setPage] = useState(1);
    const [pagesCount,setPagesCount] = useState();

    useEffect(()=>{
        let mounted = true
        const fetchData = async () => {
            try {
                setLoading(true)
                // Try localized routes first: /en/{resource} and /de/{resource}
                const urlParams = `?title=${encodeURIComponent(title)}&page=${page}&count=10`
                const reqEn = axios.get(`en/${path}${urlParams}`).catch(() => axios.get(`${path}${urlParams}&lang=en`))
                const reqDe = axios.get(`de/${path}${urlParams}`).catch(() => axios.get(`${path}${urlParams}&lang=de`))
                const [resEn, resDe] = await Promise.all([reqEn, reqDe])

                const toursEn = resEn?.data?.tours || []
                const toursDe = resDe?.data?.tours || []
                const count = resEn?.data?.count ?? resDe?.data?.count ?? 0

                // Merge by id, attach language-specific fields and keep shared meta (price, etc.)
                const deById = toursDe.reduce((acc, item) => { acc[item.id] = item; return acc }, {})
                const merged = toursEn.map(enItem => {
                    const deItem = deById[enItem.id] || {}
                    return {
                        ...enItem,
                        // Preserve a generic title for backward compatibility
                        title: enItem.title || deItem.title || enItem.title_en || deItem.title_de || '',
                        // Attach language-specific projections when available
                        title_en: enItem.title_en || enItem.title || '',
                        title_de: deItem.title_de || deItem.title || '',
                        description_en: enItem.description_en ?? enItem.description,
                        description_de: deItem.description_de ?? deItem.description,
                        key_words_en: enItem.key_words_en ?? enItem.key_words,
                        key_words_de: deItem.key_words_de ?? deItem.key_words,
                        city_en: enItem.city_en ?? enItem.city,
                        city_de: deItem.city_de ?? deItem.city,
                        text_en: enItem.text_en ?? enItem.text,
                        text_de: deItem.text_de ?? deItem.text,
                    }
                })

                if (mounted) {
                    setPost(merged)
                    setPagesCount(count)
                    setLoading(false)
                }
            } catch (e) {
                // Fallback to single request if dual-language fails entirely
                try {
                    const res = await axios.get(`${path}?title=${encodeURIComponent(title)}&page=${page}&count=10`)
                    if (mounted) {
                        setPost(res.data.tours || [])
                        setPagesCount(res.data.count || 0)
                    }
                } finally {
                    if (mounted) setLoading(false)
                }
            }
        }
        fetchData()
        return () => { mounted = false }
    },[title,page,path,setLoading,setPost])

    const handlePage = (event, value) => {
        setPage(value);
    };
    return (
        <div className='filter'>
            <div className="row p-2 align-items-center">
                <div className="col-12">
                    <div className="d-flex w-100 position-relative align-items-center">
                        <DebounceInput
                            minLength={0}
                            className='search-inp'
                            placeholder='Search by Title'
                            debounceTimeout={300}
                            onChange={e=>setTitle(e.target.value)} />
                        <span className='search-button'>
                            <FontAwesomeIcon icon={faSearch}/>
                        </span>
                    </div>
                </div>
            </div>
            <div className="row p-3 align-items-end">
                <div className="col-12 d-flex flex-row">
                    <Pagination count={Math.ceil((pagesCount || 0) / 10)} page={page} variant="outlined" color="primary" onChange={handlePage} />
                </div>
            </div>
        </div>
    );
};

export default Filter;